export const TALKVIA_WHATSAPP_NUMBER = '5519936183531';

export const talkviaWhatsappUrl = message =>
  `https://wa.me/${TALKVIA_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

// Asaas dates come as yyyy-mm-dd; keep the civil day without timezone shifts.
export const formatDueDate = value => {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : '';
};

const currency = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatAmount = value =>
  Number.isFinite(Number(value)) ? currency.format(Number(value)) : '';

export const isOverdue = payment =>
  String(payment?.status || '').toUpperCase() === 'OVERDUE';
